module.exports = __webpack_public_path__ + "img/mysql-dark.e9d1162d.svg";